import React from 'react';
import { Sparkles, Shield, UserCheck, TrendingDown } from 'lucide-react';
import css from './WhyPcific.module.css';

const VALUE_PROPS = [
  {
    id: 'ai',
    icon: Sparkles,
    label: 'PCIFIC AI',
    heading: 'AI that knows tech.',
    body: 'Get instant price checks, spec comparisons, and practical buying guidance powered by AI.',
  },
  {
    id: 'protection',
    icon: Shield,
    label: 'Buyer Protection',
    heading: 'Buy with confidence.',
    body: 'Every transaction is backed by our buyer protection guarantee. Your money is safe.',
  },
  {
    id: 'sellers',
    icon: UserCheck,
    label: 'Verified Sellers',
    heading: 'Trusted community.',
    body: 'Sellers are rated and reviewed by real buyers. Know who you\'re buying from.',
  },
  {
    id: 'deals',
    icon: TrendingDown,
    label: 'Best Prices',
    heading: 'Save more than retail.',
    body: 'Find deals on quality pre-owned and new tech. Our AI flags the best value listings.',
  },
];

/**
 * WhyPcific — Apple-style value proposition section.
 *
 * Like "Why Apple is the best place to buy Mac" — four cards
 * highlighting marketplace advantages with icon, label, heading, body.
 */
const WhyPcific = () => {
  return (
    <section className={css.root}>
      <div className={css.inner}>
        <h2 className={css.heading}>Why PCIFIC is the best place to buy.</h2>

        <div className={css.grid}>
          {VALUE_PROPS.map(prop => {
            const Icon = prop.icon;
            return (
              <div key={prop.id} className={css.card}>
                <span className={css.cardLabel}>{prop.label}</span>
                <h3 className={css.cardHeading}>{prop.heading}</h3>
                <p className={css.cardBody}>{prop.body}</p>
                <div className={css.cardIcon}>
                  <Icon size={36} strokeWidth={1.2} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyPcific;
